import { Box, Flex, SystemProps } from '@storyofams/react-ui';
import { Button } from '../Button';
import { Heading } from '../Heading';
import { Text } from '../Text';

interface CallToActionProps extends SystemProps {
  title: string;
  description: string;
  button: string;
  link: any;
}

export const CallToAction = ({
  title,
  description,
  button,
  link,
}: CallToActionProps) => {
  return (
    <Box
      height={['auto', '101px']}
      width="100%"
      maxWidth="764px"
      backgroundColor="grey800"
      borderRadius="md"
      overflow="hidden"
      display="flex"
      flexDirection="column"
    >
      <Flex
        py={[3, 0]}
        px={3}
        justifyContent="space-between"
        alignItems={['flex-start', 'center']}
        flex={1}
        flexDirection={['column', 'row']}
      >
        <Box>
          <Heading variant="h4" as="h3" color="white">
            {title}
          </Heading>
          <Text variant="m" as="p" mt={1} color="white">
            {description}
          </Text>
        </Box>
        <Button
          variant="secondary"
          href="mailto:support@trylantern.com?subject=I want to suggest a new integration"
        >
          {button}
        </Button>
      </Flex>
    </Box>
  );
};
